// Time-of-day lighting for the landing hero: one relit photo per phase in
// public/scene/hero. Cargo holds must face the viewer on the aircraft's RIGHT side.

// `sky` is the photo's top-row colour: it fills the strip above the image when the
// photo is width-fitted on desktop, so the join is invisible.
export const PHASES = [
  { id: 'dawn',   label: 'Dawn',   from: 5,  to: 9,  src: '/scene/hero/dawn.webp',   sky: '#7993b5' },
  // fx: light positions in % of the photo (x, y). Only photos with measured spots animate.
  { id: 'day',    label: 'Day',    from: 9,  to: 17, src: '/scene/hero/day.webp',    sky: '#77aee5',
    fx: { wingtip: [7.45, 35.5], tug: [7.0, 47.7] } },
  { id: 'sunset', label: 'Sunset', from: 17, to: 21, src: '/scene/hero/sunset.webp', sky: '#976069' },
  { id: 'night',  label: 'Night',  from: 21, to: 29, src: '/scene/hero/night.webp',  sky: '#04173b' },
];

export const PHASE_IDS = PHASES.map((p) => p.id);

/** Phase for a local hour (0-24, fractional allowed). Night wraps past midnight. */
export function phaseForHour(hour) {
  const h = ((hour % 24) + 24) % 24;
  const t = h < 5 ? h + 24 : h;
  return PHASES.find((p) => t >= p.from && t < p.to)?.id ?? 'day';
}

export function phaseForDate(date = new Date()) {
  return phaseForHour(date.getHours() + date.getMinutes() / 60);
}

const BLEND_H = 0.5;

/**
 * Opacity per phase for a local hour: 1 for the current phase, except in the half
 * hour before a boundary where it fades into the next one (Auto mode cross-fade).
 */
export function phaseWeights(hour) {
  const h = ((hour % 24) + 24) % 24;
  const t = h < 5 ? h + 24 : h;
  const i = PHASES.findIndex((p) => t >= p.from && t < p.to);
  const cur = PHASES[i === -1 ? 1 : i];
  const next = PHASES[(PHASES.indexOf(cur) + 1) % PHASES.length];
  const k = Math.min(1, Math.max(0, (t - (cur.to - BLEND_H)) / BLEND_H));
  const w = Object.fromEntries(PHASES.map((p) => [p.id, 0]));
  w[cur.id] = 1 - k;
  w[next.id] = k;
  return w;
}

export function srcForPhase(phase) {
  return phase.src;
}
